import { Text } from "@/components/Text";

export const EmptyDataDash = () => (
  <Text className="text-sm text-lever-text-label">—</Text>
);
